const main = async () => {
    const {default: Splide} = await import(/* webpackChunkName: "splide" */ '@splidejs/splide');

    return Splide;
}
main().then(Splide => {

        let focusedElBeforeOpen;
        let nonModalNodes;
        let productImageRotator;

        // Create Dialog
        function Dialog(dialogEl, overlayEl) {

            this.dialogEl = dialogEl;
            this.overlayEl = overlayEl;

            var focusableEls = this.dialogEl.querySelectorAll('a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), [tabindex="0"]');

            this.focusableEls = Array.prototype.slice.call(focusableEls);

            this.firstFocusableEl = this.focusableEls[0];

            this.close(); // Reset
        }

        // Dialog Open Event
        Dialog.prototype.open = function() {

            var Dialog = this;

            document.getElementsByTagName('body')[0].classList.add('open');

            focusedElBeforeOpen = document.activeElement;

            let modalNodes = Array.from( document.querySelectorAll('.dialog *') );

            // by only finding elements that do not have tabindex="-1" we ensure we don't
            // corrupt the previous state of the element if a modal was already open
            nonModalNodes = document.querySelectorAll('body *:not(.dialog):not([tabindex="-1"])');

            for (let i = 0; i < nonModalNodes.length; i++) {
                let node = nonModalNodes[i];

                if (!modalNodes.includes(node)) {
                    // save the previous tabindex state so we can restore it on close
                    node._prevTabindex = node.getAttribute('tabindex');
                    node.setAttribute('tabindex', -1);
                }
            }

            this.dialogEl.removeAttribute('aria-hidden');
            this.overlayEl.removeAttribute('aria-hidden');

            this.dialogEl.addEventListener('keydown', function(e) {
                Dialog._handleKeyDown(e);
            });

            this.overlayEl.addEventListener('click', function() {
                Dialog.close();
            });

            this.firstFocusableEl.focus();
        };
        // Dialog Close Event
        Dialog.prototype.close = function() {

            document.getElementsByTagName('body')[0].classList.remove('open');

            // restore or remove tabindex from nodes
            if (nonModalNodes) {
                for (let i = 0; i < nonModalNodes.length; i++) {
                    let node = nonModalNodes[i];
                    if (node._prevTabindex) {
                        node.setAttribute('tabindex', node._prevTabindex);
                        node._prevTabindex = null;
                    }
                    else {
                        node.removeAttribute('tabindex');
                    }
                }
            }

            this.dialogEl.setAttribute('aria-hidden', true);
            this.overlayEl.setAttribute('aria-hidden', true);

            if (focusedElBeforeOpen) {
                focusedElBeforeOpen.focus();
            }
        };
        // Dialog Key Down Event
        Dialog.prototype._handleKeyDown = function(e) {

            var Dialog = this;
            var KEY_ESC = 'Escape';

            switch (e.key) {
                case KEY_ESC:
                    Dialog.close();
                    break;
                default:
                    break;
            }

        };
        // Dialog Event Listeners
        Dialog.prototype.addEventListeners = function(openDialogSel, closeDialogSel) {

            var Dialog = this;

            var openDialogEls = document.querySelectorAll(openDialogSel);

            const openers = document.querySelectorAll('.open-dialog');
            const openersArray = Array.prototype.slice.call(openers);

            for (var i = 0; i < openDialogEls.length; i++) {
                openDialogEls[i].addEventListener('click', function() {
                    let index = openersArray.indexOf( event.currentTarget );
                    Dialog.open();
                    if (event.currentTarget.classList.contains('view-all')) {
                        productImageRotator.go(0);
                    } else {
                        productImageRotator.go(index);
                    }
                });
            }

            var closeDialogEls = document.querySelectorAll(closeDialogSel);
            for (var i = 0; i < closeDialogEls.length; i++) {
                closeDialogEls[i].addEventListener('click', function() {
                    Dialog.close();
                });
            }

        };

        // global nav dialog
        const navDialogEl = document.querySelector('.dialog');
        const dialogOverlay = document.querySelector('.dialog-overlay');
        let myDialog = new Dialog(navDialogEl, dialogOverlay);
        myDialog.addEventListeners('.open-dialog', '.close-dialog');

        if (!productImageRotator) {
            // create home product image rotator
            productImageRotator = new Splide('.product-images', {
                classes: {
                    arrows: 'splide__arrows dialog__arrows',
                    prev  : 'splide__arrow dialog__prev-product',
                    next  : 'splide__arrow dialog__next-product',
                },
                keyboard: true,
                pagination: false,
                start: 1,
                track: {
                    ariaAtomic: true,
                    ariaLive: true,
                    ariaBusy: true
                }
            });
            // mount image rotator
            productImageRotator.mount();
            productImageRotator.go(1);
            // return instance
            return productImageRotator;
        }
    })
    .catch((error) => {
        console.log(error);
        console.log('Unable to load Product image rotator module');
    });